import { ClockType } from '../../apis/Clock.api';
import React from 'react';

interface props {
  anemoX: number;
  anemoY: number;
  clockData: ClockType;
}

export const Clock: React.FC<props> = (props) => {
  const clockData = props.clockData;

  return (
    <>
      <g fill='white'>
        <text y={50} fontSize='52' color='white'>
          {(clockData.now.getMonth() + 1).toString().padStart(2, '0') +
            '.' +
            clockData.now.getDate().toString().padStart(2, '0')}
        </text>
        <text x={24} y={100} fontSize='34' color='white'>
          {clockData?.weekday}
        </text>
        <text x={130} y={100} fontSize='120' color='white'>
          {clockData !== undefined &&
            `${
              clockData.now.getHours().toString().padStart(2, '0') +
              ':' +
              clockData.now.getMinutes().toString().padStart(2, '0')
            }`}
        </text>
        <text x={420} y={98} fontSize='46' color='white'>
          {clockData !== undefined &&
            clockData.now.getSeconds().toString().padStart(2, '0')}
        </text>
      </g>
    </>
  );
};
